<template>
  <div class="hidden md:flex md:items-center">
    <div class="grow">
      <h1 class="text-static-default-mid heading-1">
        {{ i18n(translations.title) }}
      </h1>
      <p class="text-static-default-low body-1 mt-20">
        {{ i18n(translations.message) }}
      </p>
      <RevButton
        class="mt-32"
        :to="{
          name: ROUTE_NAMES.BUYBACK.SEARCH_PRODUCT,
        }"
        variant="primary"
      >
        {{ i18n(translations.createListing) }}</RevButton
      >
    </div>
    <RevIllustration
      alt="No listings"
      :height="248"
      :src="'/img/buyback/no-buyback-listings.svg'"
      :width="448"
    />
  </div>

  <div class="flex flex-col md:hidden">
    <p class="text-static-default-low mb-8">
      {{ i18n(translations.emptyStateSurtitle) }}
    </p>
    <h1 class="text-static-default-mid heading-1">
      {{ i18n(translations.title) }}
    </h1>
    <p class="text-static-default-low body-1 mb-32 mt-20">
      {{ i18n(translations.message) }}
    </p>
    <RevIllustration
      alt="No listings"
      :height="248"
      :src="'/img/buyback/no-buyback-listings.svg'"
      :width="448"
    />
    <RevButton
      class="mt-56"
      :to="{
        name: ROUTE_NAMES.BUYBACK.SEARCH_PRODUCT,
      }"
      variant="primary"
    >
      {{ i18n(translations.createListing) }}</RevButton
    >
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './NoOffer.translations'

const i18n = useI18n()
</script>
